import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.src)
      ? (_openBlock(), _createBlock(_component_v_img, {
          key: 0,
          src: _ctx.src,
          onerror: "style.display:'none'",
          style: _normalizeStyle(_ctx.cssStyle)
        }, null, 8, ["src", "style"]))
      : _createCommentVNode("", true)
  ]))
}